import type { SlaTranslation } from './types';

export const slaHi: SlaTranslation = {
  badge: {
    dueIn: 'जवाब {{time}} में देना है',
    dueSoon: 'जवाब {{time}} में देना है',
    dueNow: 'जवाब अभी देना है',
    overdue: '{{time}} देर हो चुकी है',
    paused: 'जवाब का समय रुका है',
    outsideHours: 'जवाब का समय कामकाजी घंटों का इंतज़ार कर रहा है',
    first_reply: 'पहला जवाब',
    next_reply: 'अगला जवाब',
    detail: '{{kind}} का लक्ष्य: {{target}}।',
  },
  urgent: {
    title: 'अर्जेंट, किसी ने नहीं लिया',
    count: '{{n}} अर्जेंट',
    more: '{{total}} में से {{shown}} दिखाए गए हैं। सबसे पहले जिनकी समय-सीमा पास है।',
    claim: 'लें',
    claimName: '{{name}} के साथ बातचीत लें',
    claimed: '{{name}} के साथ बातचीत अब आपकी है।',
    waited: '{{time}} से इंतज़ार',
    reason: {
      customer_request: 'किसी इंसान से बात करना चाहा',
      ai_escalated: 'AI ने सौंप दी',
      ai_unavailable: 'AI जवाब नहीं दे सका',
      ai_blocked: 'AI को जवाब देने से रोका गया',
      ai_limit: 'AI अपनी सीमा तक पहुँच गया',
      staff_release: 'कतार में वापस रखी गई',
      channel_ai_off: 'इस चैनल पर AI जवाब नहीं देता',
      sla_moved: 'हटाई गई: किसी ने समय पर जवाब नहीं दिया',
      other: 'किसी इंसान का इंतज़ार',
    },
  },
  lost: {
    staff: '{{name}} यह बातचीत पहले ही ले चुके हैं।',
    ai: '{{name}} अब इस बातचीत का जवाब दे रहा है।',
    external: 'Chatwoot में किसी ने यह बातचीत पहले ही ले ली है।',
    none: 'किसी और ने यह बातचीत पहले बदल दी। अब दिखाया जा रहा है कि यह कहाँ है।',
  },
  settings: {
    title: 'जवाब के समय के लक्ष्य',
    description:
      'प्राथमिकता के हिसाब से आपकी टीम को कितनी जल्दी जवाब देना चाहिए। समय सिर्फ़ ऊपर दिए कामकाजी घंटों में गिना जाता है, और बातचीत स्नूज़ होने पर रुक जाता है।',
    guide: 'जवाब के समय के लक्ष्य कैसे काम करते हैं',
    enabled: 'इस ब्रांड के लिए जवाब के समय के लक्ष्य इस्तेमाल करें',
    enabledHint:
      'इंसान का इंतज़ार कर रही बातचीत दिखाती है कि जवाब कब तक देना है, और देर होने पर देरी वाली कतार में चली जाती है।',
    priority: 'प्राथमिकता',
    firstReply: 'पहला जवाब इतने समय में',
    nextReply: 'अगला जवाब इतने समय में',
    amount: '{{priority}} के लिए {{column}}',
    unit: '{{column}} की इकाई, {{priority}}',
    minutes: 'मिनट',
    hours: 'घंटे',
    empty: 'कोई लक्ष्य नहीं',
    noPriority: 'बिना प्राथमिकता वाली बातचीत मध्यम के लक्ष्य इस्तेमाल करती है।',
    invalid: '{{priority}} के लिए {{column}}: 1 मिनट से 7 दिन तक की पूरी संख्या डालें, या खाली छोड़ें।',
    save: 'लक्ष्य सहेजें',
    saved: '{{name}} के लिए जवाब के समय के लक्ष्य सहेजे गए।',
    overdue: {
      title: 'जब कोई बातचीत अपने लक्ष्य से आगे निकल जाए',
      alertLeads: 'टीम लीड को तुरंत सूचना दें',
      alertLeadsHint:
        'जो लोग बातचीत सौंप सकते हैं, उन्हें Studio में पता चलता है। जो ऑनलाइन नहीं हैं, उन्हें ईमेल मिलता है, हर 15 मिनट में ज़्यादा से ज़्यादा एक।',
      move: 'कोई जवाब न दे तो इसे हटाएँ',
      moveHint:
        'यह कतार में वापस जाती है, या आपकी चुनी टीम में, और अगले व्यक्ति को पेश की जाती है। ग्राहक को नहीं बताया जाता।',
      after: 'इसके बाद हटाएँ',
      afterUnit: 'हटाने से पहले के इंतज़ार की इकाई',
      afterHint: 'लक्ष्य से आगे निकलने के बाद, कामकाजी घंटों में गिना जाता है।',
      moveTo: 'यहाँ हटाएँ',
      queue: 'कतार (इसकी टीम वही रहती है)',
      team: '{{name}} टीम',
      teamGone: 'एक टीम जो अब बातचीत नहीं लेती',
      invalidAfter: 'इसके बाद हटाएँ: 1 मिनट से 7 दिन तक की पूरी संख्या लिखें।',
    },
    loading: 'जवाब के समय के लक्ष्य लोड हो रहे हैं',
  },
  moved: 'कतार में वापस: जवाब के समय के लक्ष्य के भीतर किसी ने जवाब नहीं दिया।',
};
